import React from 'react';

const Section = ({ title, children }) => (
  <div className="space-y-2">
    <h4 className="font-bold text-[var(--text-primary)]">{title}</h4>
    {children}
  </div>
);

export const PrivacyPolicy = () => (
  <div className="space-y-4 text-sm text-[var(--text-secondary)] max-h-[60vh] overflow-y-auto pr-4">
    <p><strong>Effective Date:</strong> January 14, 2026</p>
    <p>At Digital Leader Project, we value your privacy. This Privacy Policy explains how we collect, use, and protect your personal information.</p>

    <Section title="1. Information We Collect">
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Personal Information:</strong> We collect personal information like your name and email when you contact us or fill out the contact form on our website.</li>
        <li><strong>Technical Information:</strong> We collect non-personal information, such as your IP address and browser type, to improve the performance and security of the website.</li>
      </ul>
    </Section>

    <Section title="2. How We Use Your Information">
      <ul className="list-disc pl-5 space-y-1">
        <li>To respond to your inquiries or provide services.</li>
        <li>To improve our website and services.</li>
      </ul>
    </Section>

    <Section title="3. Cookies">
      <p>We may use cookies to improve website functionality. You can adjust your browser settings to block cookies, though some features of the website may not work properly.</p>
    </Section>

    <Section title="4. Data Protection">
      <p>We take reasonable measures to secure your information. However, no data transmission over the internet can be guaranteed as 100% secure.</p>
    </Section>

    <Section title="5. Sharing Your Information">
      <p>We do not sell, rent, or share your personal data with third parties, except for service providers we may use to support our website and services (e.g., email providers like SendGrid).</p>
    </Section>

    <Section title="6. Your Rights">
      <p>You have the right to access, update, or delete the personal information we hold about you. If you want to exercise any of these rights, please contact us at digitalleaderproject@gmail.com.</p>
    </Section>

    <Section title="7. Changes to This Privacy Policy">
      <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page, and the effective date will be updated accordingly.</p>
    </Section>

    <div className="pt-4 border-t border-[var(--border-medium)]">
      <p><strong>Contact Information:</strong></p>
      <p>If you have any questions about our Privacy Policy, please contact us at: digitalleaderproject@gmail.com</p>
    </div>
  </div>
);
